import { buffers, END, eventChannel } from 'redux-saga';
import { IUploadFile } from '../filesInterfaces';

export function createUploadFileChannel(httpVerb: 'PUT' | 'POST', request: IUploadFile) {
  return eventChannel(emitter => {
    const onProgress = (e: ProgressEvent) => {
      if (e.lengthComputable) {
        const progress = e.loaded / e.total;
        emitter({ progress });
      }
    };
    const onFailure = (e: ProgressEvent) => {
      emitter({ err: new Error('Upload failed') });
      emitter(END);
    };

    const xhr = new XMLHttpRequest();

    // add event functions
    xhr.upload.addEventListener('progress', onProgress);
    xhr.upload.addEventListener('error', onFailure);
    xhr.upload.addEventListener('abort', onFailure);

    xhr.onreadystatechange = () => {
      const { readyState, status } = xhr;
      if (readyState === 4) {
        if (status >= 200 && status <= 299) {
          emitter({ success: true });
          emitter(END);
        } else {
          emitter({ err: new Error('Upload failed') });
          emitter(END);
        }
      }
    };

    xhr.open(httpVerb, request.url, true);

    // set blob type for azure
    xhr.setRequestHeader('x-ms-blob-type', 'BlockBlob');

    xhr.send(request.file);
    return () => {
      xhr.upload.removeEventListener('progress', onProgress);
      xhr.upload.removeEventListener('error', onFailure);
      xhr.upload.removeEventListener('abort', onFailure);
      xhr.onreadystatechange = null;
      xhr.abort();
    };
  }, buffers.sliding(2));
}
